import { render, staticRenderFns } from "./dialogNode.vue?vue&type=template&id=60150046"
import script from "./dialogNode.vue?vue&type=script&lang=js"
export * from "./dialogNode.vue?vue&type=script&lang=js"
import style0 from "./dialogNode.vue?vue&type=style&index=0&id=60150046&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports